function guid() {
	function e() {
		return Math.floor((1 + Math.random()) * 65536).toString(16).substring(1);
	}
	return e() + e() + "-" + e() + "-" + e() + "-" + e() + "-" + e() + e() + e();
}
var events = {}, activeStreams = [];
function getHandler(e) {
	return events[e];
}
function addHandler(e, i) {
	return events[e] = events[e] || [], events[e].push(i), () => {
		let a = events[e].indexOf(i);
		a !== -1 && events[e].splice(a, 1);
	};
}
function execute(e, r, a, o) {
	return new Promise(function(s, c) {
		window.top === window.self && e !== "window.kiosk.method.login" && c(/* @__PURE__ */ Error("err.kiosk.NotInIframe"));
		let l = createStream(e, r || {}, a);
		l.onmessage = a, l.resolve = s, l.reject = (r) => {
			r = typeof r == "string" ? Error(r) : r instanceof Error ? r : Error(JSON.stringify(r) || "undefinedError"), r.function = e, c(r);
		}, activeStreams.push(l), o && setTimeout(() => {
			let e = activeStreams.findIndex((e) => e.guid = l.guid);
			e >= 0 && activeStreams.splice(e, 1), c(/* @__PURE__ */ Error("clr.Timout"));
		}, o);
	});
}
function createStream(r, i, a) {
	let o = {
		guid: guid(),
		method: r,
		input: i,
		onmessage: !!a,
		resolve: void 0,
		reject: void 0
	};
	return window.parent.postMessage(o, "*"), o;
}
window.onmessage = function(e) {
	let r = e.data;
	if (r.event) {
		let e = getHandler(r.event);
		for (let i of e || []) i && i(r);
	} else if (r.guid) {
		let e = activeStreams.findIndex((e) => e.guid === r.guid);
		if (e === -1) throw Error("critical error, stream not found");
		let a = Object.assign(r, activeStreams[e]);
		if (a.onmessage && a.success == null) {
			a.onmessage(a.messageObj);
			return;
		} else a.success == 1 ? a.resolve(a.result) : a.success == 0 && a.reject(a.result);
		activeStreams.splice(e, 1);
	}
};
var _lastEvent = null;
document.addEventListener("keyup", function(e) {
	let r = e.key;
	if (r != "Shift") {
		let i = _lastEvent;
		(e.shiftKey || i && i.key == "Shift" && e.timeStamp - i.timeStamp < 100) && (r = r.toUpperCase()), window.parent.postMessage({ keypress: {
			keyCode: e.keyCode,
			which: e.which,
			key: r
		} }, "*");
	}
	_lastEvent = e;
});
var __bridgeStore__ = { tseTransaction: void 0 };
const KioskBridge = {
	onEvent: (e, r) => addHandler(e, r),
	onLogin(e) {
		return addHandler("login", e);
	},
	onScanCode(e) {
		return addHandler("scanCode", e);
	},
	execute: (e, r, i, a) => execute(e, r, i, a),
	cashDispenser: {
		openUtilities: () => execute("cashDispenser.kiosk.maintenanceModal"),
		cancel: () => execute("cashDispenser.kiosk.cancel"),
		returnLast: () => execute("cashDispenser.kiosk.cancel", { returnLastAmount: !0 })
	},
	cashdrawer: { open: () => execute("cashDrawer.kiosk.open") },
	getCashregister: () => execute("cashregister.kiosk.getCashregister"),
	getSettings: () => execute("setting.kiosk.get.settingObj"),
	close: () => execute("index.close"),
	refresh: () => execute("index.refresh.kiosk.openRefresh"),
	devTools: () => execute("index.kiosk.openDevTools"),
	restart: () => execute("cashregister.kiosk.restart"),
	reload: () => window.location.reload(),
	receipt: {
		showHistory: () => execute("receipt.history.kiosk.openHistory"),
		stop: () => execute("receipt.kiosk.stop"),
		printLast: () => execute("printer.kiosk.print.lastReceipt"),
		print: (e) => execute("printer.kiosk.print.receipt", { divisionId: e }),
		printPrinterGroup: async (e) => {
			let r = await KioskBridge.execute("receipt.history.online.receipt", { divisionId: e });
			return KioskBridge.execute("printerGroup.kiosk.receipt", {
				receiptObject: r,
				fromDb: !0
			});
		},
		getReceipt: (e) => execute("receipt.history.rest.get.receipt", { headerId: e })
	},
	blackbox: {
		getCurrentTransaction: async () => __bridgeStore__.tseTransaction,
		startTransaction: async (e) => {
			let r = await KioskBridge.blackbox._getTseObject(e), i = await KioskBridge.blackbox.getCurrentTransaction();
			i && await KioskBridge.blackbox.endTransaction(e, i);
			let a = await execute("swissbit.windows.startTransaction", r);
			return __bridgeStore__.tseTransaction = {
				...a,
				order: e
			}, a;
		},
		endTransaction: async (e, r) => {
			if (r ||= __bridgeStore__.tseTransaction, !r) throw Error("Error no TSE Transaction found.");
			let i = await KioskBridge.blackbox._getTseObject(e, r), a = await execute("swissbit.windows.finishTransaction", i);
			return __bridgeStore__.tseTransaction?.transactionNumber == a.transactionNumber && (__bridgeStore__.tseTransaction = void 0), a;
		},
		_getTseObject: async (e, r) => {
			let i = await KioskBridge.blackbox.getParams();
			if (!i) throw Error("TSE Error. TSE Configuration is not set.");
			if (!e) throw Error("Error. No Order for TSE.");
			return {
				...await KioskBridge.getCashregister(),
				...i,
				receiptDateTime: void 0,
				division: void 0,
				receipt: { ...e },
				...r || {}
			};
		},
		getParams: async () => {
			try {
				return await execute("swissbit.get.params");
			} catch (e) {
				if (e.message === "wrn.Swissbit.TurnedOff") return;
				throw e;
			}
		}
	},
	payment: {
		createLine: async (e, r, i) => await execute("payment.keyboard.kiosk", {
			paymentId: e,
			payAmount: r,
			addToReceipt: !1
		}, i),
		stopEft: () => execute("eft.abort")
	},
	employee: { login: async (e) => {
		let r = await execute("employee.get.employee", e);
		return execute("employee.set.employee.active", r);
	} },
	login: async () => execute("window.kiosk.method.login", { sendEvent: !0 }),
	shift: {
		checkBatch: () => execute("cashregister.shift.kiosk.checkBatch"),
		end: () => execute("cashregister.shift.kiosk.open")
	}
};
export { KioskBridge, guid };
